import React, {Component} from 'react';
import moment from "moment";
import "./index.css";
import {Collapse} from 'reactstrap';
import ProfilePic from "../../../../ProfilePic";
import CommentDropDown from "../more";
import CommentInput from "../textarea";
import comment_util from "../../../../../util/clipstore/user/comment";
import reply_util from "../../../../../util/clipstore/user/reply";
import assets from "../../../../../util/assets";
import strings from "../../../../../util/strings";
import Replies from "../../../../../container/Replies";

class CommentListItem extends Component {
    constructor() {
        super();
        this.state = {
            isEditOpen: false,
            isOpen: false,
            replyText: '',
            deleteComment: {},
            updateComment: {},
            isHovered: false
        }

        this.handleHover = this.handleHover.bind(this);
    }

    componentDidMount() {
    }

    getDropDownItem = (props) => {
        const commentedByUserID = props.comment.user.id

        if (props.currentUser.hasOwnProperty("user_id") && props.currentUser.user_id === commentedByUserID) {
            //same user as commented
            return comment_util.getUserDropDownItem(() => {
                this.setUpdateComment(props.comment);
            }, () => {
                let payload = {
                    image: assets.clipstore.delete_icon,
                    title: strings.comment.delete.title,
                    description: strings.comment.delete.description,
                };

                if (props.type === "reply") {
                    payload = {
                        image: assets.clipstore.delete_icon,
                        title: strings.reply.delete.title,
                        description: strings.reply.delete.description,
                    };
                }
                const isConfirmationModal = true;
                const actionArray = [{
                    text: "CANCEL",
                    click: () => {
                        props.hideCommonModal()
                    }
                }, {
                    text: "DELETE",
                    click: () => {
                        this.setDeleteComment(props.comment)
                        if(props.type === "reply"){
                            reply_util.deleteReplyAPI(this.props, props.comment.comment_id)
                        }else if(props.type === "comment"){
                            comment_util.deleteCommentAPI(this.props, props.comment.comment_id)
                        }
                    }
                }];

                props.showCommonModal(payload, isConfirmationModal, actionArray);
            }, () => {
                console.log("report >> comment", props.comment);
            })
        } else {
            //this is guest
            return comment_util.getOtherUserDropDownItem(() => {
                console.log("report >> comment", props.comment);
            })
        }
    }

    setUpdateComment = (updateComment) => {
        this.setState({
            updateComment,
            commentText: updateComment.hasOwnProperty("text") ? updateComment.text : ""
        })
    }

    setCommentText = (comment) => {
        this.setState({
            commentText: comment
        })
    }

    setDeleteComment = (comment) => {
        this.setState({
            deleteComment: comment
        }, () => {
            this.props.setDeleteComment(comment);
        })
    }

    setReplyText = (replyText) => {
        this.setState({
            replyText: replyText
        })
    }

    toggle = () => {
        this.setState({
            isOpen: !this.state.isOpen
        })
    }

    toggleEditOpen = () => {
        this.setState({
            isEditOpen: !this.state.isEditOpen
        })
    }

    isEditOpen = (comment_id) => {
        if (this.state.updateComment.hasOwnProperty("comment_id")) {
            return this.state.updateComment.comment_id === comment_id
        }
        return false;
    }

    handleHover() {
        this.setState(prevState => ({
            isHovered: !prevState.isHovered
        }));
    }

    render() {
        const dropDownItem = this.getDropDownItem(this.props);
        return (
            <div className="comment-list-item-container">
                <div className="comment-list-item" onMouseEnter={this.handleHover} onMouseLeave={this.handleHover}>
                    <ProfilePic
                        onClick={() => {
                            console.log("Clicked on profile", this.props.comment.user)
                        }}
                        profile_pic={this.props.comment.user.profile_pic}
                        is_verified={0}
                        user_type={"user"}
                    />
                    <div className="comment-list-item-text">
                        <div>
                            <span className="comment-list-item-username">{this.props.comment.user.username}</span>
                            <span
                                className="comment-list-item-from-now">{moment.utc(this.props.comment.created_at).local().fromNow()}</span>
                        </div>
                        <Collapse isOpen={this.isEditOpen(this.props.comment.comment_id)} style={{marginTop: 10}}>
                            <CommentInput
                                showLogin={this.props.showLogin}
                                profile_pic={this.props.currentUser.profile_pic}
                                user_type={"user"}
                                text={this.state.commentText}
                                setText={this.setCommentText}
                                isFetching={false}
                                actionText={"SAVE"}
                                onActionClick={() => {
                                    //API call to submit comment
                                    if (this.props.type && this.props.type === "comment") {
                                        comment_util.updateCommentAPI(this.props,
                                            this.props.comment.comment_id,
                                            {
                                                "text": this.state.commentText,
                                                "device": this.props.device
                                            })
                                    } else if (this.props.type && this.props.type === "reply") {
                                        reply_util.updateReplyAPI(this.props,
                                            this.props.comment.comment_id,
                                            {
                                                "text": this.state.commentText,
                                                "device": this.props.device
                                            })
                                    }
                                    this.setUpdateComment({});
                                }}
                                hideBottomArea={() => {
                                    this.setUpdateComment({});
                                }}
                            />
                        </Collapse>
                        <Collapse isOpen={!this.isEditOpen(this.props.comment.comment_id)} style={{marginTop: 10}}>
                            <div className="comment-list-item-comment">{this.props.comment.text}</div>
                            <Replies comment_id={this.props.comment.comment_id}
                                     showLogin={this.props.showLogin}
                                     reply_count={this.props.comment.reply_count} currentUser={this.props.currentUser}/>
                        </Collapse>
                    </div>
                    {
                        this.state.isHovered &&
                        <div className="display-flex comment-list-item-reply-container">
                            {this.props.type && this.props.type === "comment" &&
                            <div className="comment-list-item-reply" onClick={this.toggle}>REPLY</div>
                            }
                            <CommentDropDown dropDownItem={dropDownItem} commentId={this.props.comment.comment_id}/>
                        </div>
                    }
                    {/*{this.state.isHovered && <div className="comment-list-item-reply" onClick={this.toggle}>REPLY</div>}*/}
                    {/*{this.state.isHovered && <CommentDropDown dropDownItem={dropDownItem} commentId={this.props.comment.comment_id}/>}*/}
                </div>

                {
                    this.props.type && this.props.type === "comment" &&
                    <Collapse isOpen={this.state.isOpen} style={{marginLeft: 45, marginTop: 10}}>
                        <CommentInput
                            showLogin={this.props.showLogin}
                            profile_pic={this.props.currentUser.profile_pic}
                            placeholder={"Add a public reply"}
                            user_type={"user"}
                            text={this.state.replyText}
                            setText={this.setReplyText}
                            isFetching={false}
                            actionText={"REPLY"}
                            onActionClick={() => {
                                console.log("Reply action");
                                //API call to submit comment
                                reply_util.createReplyAPI(this.props, this.props.comment.comment_id, {
                                    "text": this.state.replyText,
                                    "device": this.props.device
                                })

                                this.props.setRepliedComment(this.props.comment)
                                this.setReplyText("");
                                this.toggle();
                            }}
                            hideBottomArea={() => {
                                this.setReplyText("");
                                this.toggle();
                            }}
                        />
                    </Collapse>
                }
            </div>
        );
    }
}

CommentListItem.propTypes = {};

export default CommentListItem;
